import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=4a9bb0e3&scoped=true&"
import script from "./ListDocuments.ts?vue&type=script&lang=ts&"
export * from "./ListDocuments.ts?vue&type=script&lang=ts&"
import style0 from "./ListDocuments.scss?vue&type=style&index=0&id=4a9bb0e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bb0e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VDialog,VIcon,VProgressCircular,VRow,VSheet,VTooltip})
